import { render, staticRenderFns } from "./WallOfLoveView.vue?vue&type=template&id=3f42be1c&scoped=true&"
import script from "./WallOfLoveView.vue?vue&type=script&lang=js&"
export * from "./WallOfLoveView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/wall.css?vue&type=style&index=0&id=3f42be1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42be1c",
  null
  
)

export default component.exports